import React, {useEffect, useState, useContext} from 'react'
import { useHistory } from 'react-router-dom';
import CrearSolicitudBeneficio from './crearSolicitudBeneficio/CrearSolicitudBeneficio';
import PageHeader from '../../../components/pageHeader/PageHeader';
import PageButtons from '../../../components/pageComponents/PageButtons';
import PageWrapper from '../../../components/pageComponents/PageWrapper';
import PaginatorV2 from '../../../components/pageComponents/PaginatorV2';
import ModalEnabled from '../../../components/modalComponents/ModalEnabled';
import SearchContainer from '../../../components/pageComponents/SearchContainer';
import useDidMountEffect from '../../../hooks/useDidMountEffect/useDidMountEffect';
import {useGetRequest} from '../../../hooks/useGetRequest/useGetRequest';
import {useManagePostRequest} from '../../../hooks/useManagePostRequest/useManagePostRequest';
import {initialAllOptionPromises, jsonNoEstaVacio, updateFiltersWithExtraData} from '../../../helper/utils';
import {
    getAllCargosAPI,
    getAllEstadosAPI,
    getAllSedesAPI,
    getInitialDataToSolicitarBeneficioItemAPI, getAllAreasAPI, getListaMisSolicitudesBeneficiosAPI,
    getCampaniaCatalogoAPI
} from '../../../consumers/backendApisUrls';
import SolicitudDescuentoVale from '../../../pages/misSolicitudes/solicitudDescuentoVale/SolicitudDescuentoVale';
import SolicitudDescuentoPension from '../../../pages/misSolicitudes/solicitudDescuentoPension/SolicitudDescuentoPension';
import ListaCuponeras from '../../../pages/cuponeraTiempoLibre/misSolicitudesCupon/ListaCuponeras';

import {AuthContext} from '../../../hooks/context/authContext';
import {useManageGetRequest} from "../../../hooks/useManageGetRequest/useManageGetRequest";
import {toast} from "react-toastify";
import TableSolicitudesBeneficios from "./TableSolicitudesBeneficios";

import Wrapper from '../../../components/atoms/DirectorioWrapper';
import TableCatalogItems from './TableCatalogItems';

const INIT_KEYS = {
    IdsCargos: "IdsCargos",
    IdsAreas: "IdsAreas",
    IdsSedes: "IdsSedes",
    IdsEstadosSolicitud: "IdsEstadosSolicitud"
};

const MisSolicitudesBeneficios = () => {
    const {state} = useContext(AuthContext);
    const history = useHistory();
    const [formValues, setFormValues] = useState({Items: [], ExtraData: {}, filters: [], selectedFilters: {}});
    const [formCatalogValues, setFormCatalogValues] = useState({
        Items: [],
        ExtraData: {},
        filters: [],
        selectedFilters: {},
      });
    const [allFilters, setAllFilters] = useState([]);

    const [searchCriteria, setSearchCriteria] = useState("");
    const [paginator, setPaginator] = useState({CurrentPage: 1});
    const [paginatorCatalog, setPaginatorCatalog] = useState({CurrentPage: 1});
    const [isLoading, setIsLoading] = useState(true);
    const [criterioDeBusquedaCatalogo, setCriterioDeBusquedaCatalogo] = useState("");
    const [modalEnabled, setModalEnabled] = useState({isEnable: false, component: React.Fragment});

    const [executeGet] = useGetRequest();
    const [executeManagePost] = useManagePostRequest();
    const [executeManageGet] = useManageGetRequest();

    const initialPromises = () => {
        const response = executeGet(getAllEstadosAPI());

        return [
            executeGet(getAllCargosAPI()),
            executeGet(getAllAreasAPI()),
            executeGet(getAllSedesAPI()),
            response
        ];
    }

    const init = async () => {
        setIsLoading(true);
        try {
            await initialAllOptionPromises(initialPromises, Object.values(INIT_KEYS), setAllFilters);
            await manageSearch();
            if (formValues.filters.length === 0) {
                jsonNoEstaVacio(formValues.ExtraData) &&
                updateFiltersWithExtraData(allFilters, formValues.ExtraData, handleUpdatedFilters);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    }

    const manageSearch = async () => {
        setIsLoading(true);
        const api = getListaMisSolicitudesBeneficiosAPI();        
        const payload = getPayload();
        await executeManagePost(api, payload, successManageSearchCallback);
        setIsLoading(false);
    }

    const manageSearchCatalog = async() => {
        setIsLoading(true);
        const api = getCampaniaCatalogoAPI();
        const payload = getPayloadCatalog();
        try {
            await executeManagePost(api, payload, successManageSearchCatalogCallback);
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }        
    }

    const getPayload = () => {
        return {
            Criteria: searchCriteria,
            Page: paginator.CurrentPage,
            ...formValues.selectedFilters
        }
    }
    const getPayloadCatalog = ()=> {
        return {      
            Page: paginatorCatalog.CurrentPage,
        };
    }

    const successManageSearchCallback = ({data}) => {
        const {Items, ExtraData, TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage} = data;
        setFormValues(lastData => ({...lastData, Items, ExtraData}));
        setPaginator({TotalItems, FirsItemPage, LastItemPage, TotalPages, CurrentPage});
    }

    const successManageSearchCatalogCallback = ({ data }) => {
        const {
            Items,
            ExtraData,
            TotalItems,
            FirsItemPage,
            LastItemPage,
            TotalPages,
            CurrentPage,
        } = data;
        setFormCatalogValues((lastData) => ({
            ...lastData,
            Items,
            ExtraData,
        }));
        setPaginatorCatalog({
            TotalItems,
            FirsItemPage,
            LastItemPage,
            TotalPages,
            CurrentPage,
        });

    }

    const handleUpdatedFilters = (res) => {
        setFormValues(lastData => ({...lastData, filters: res}))
    }

    const handleCleanSearch = () => {
        setFormValues({...formValues, selectedFilters: null});
    }

    useDidMountEffect(() => {
        manageSearch();
    }, [paginator.CurrentPage, formValues.selectedFilters])

    useDidMountEffect(() => {
        jsonNoEstaVacio(formValues.ExtraData) && updateFiltersWithExtraData(allFilters, formValues.ExtraData, handleUpdatedFilters);
    }, [formValues.ExtraData])

    useEffect(() => {
        init();
    }, [])

    useEffect(() => {
        manageSearchCatalog();
    }, [criterioDeBusquedaCatalogo, paginatorCatalog.CurrentPage])


    async function getInitialDataToCreateSolicitud() {
        try {
            const api = getInitialDataToSolicitarBeneficioItemAPI();
            await executeManageGet(api, (res) => successCallbackInitialData(res), false);
        } catch (error) {
            console.error(error)
        }
    }

    const successCallbackInitialData = (res) => {
        if ( typeof res?.data?.ErrorMessage === "string" && res?.data?.ErrorMessage.trim().length > 0)
            toast.error(res?.data?.ErrorMessage);
        else{
            setModalEnabled({
                isEnable: true,
                component: CrearSolicitudBeneficio,
                data: {idEmpleado: state.user.id_empleado}
            })
        }
    }

    // const manejarRespuestaValidacion = (res, idCampanaBeneficioPreseleccionada = null) => {
    //     if (typeof res?.data?.ErrorMessage === "string" && res?.data?.ErrorMessage.trim().length > 0) {
    //         toast.error(res.data.ErrorMessage);
    //     } else {
    //         setModalEnabled({
    //             isEnable: true,
    //             component: CrearSolicitudBeneficio,
    //             data: {
    //                 idEmpleado: state.user.id_empleado,
    //                 idCampanaBeneficioPreseleccionada
    //             }
    //         });
    //     }
    // };

    const validarYAbrirSolicitud = async (idCampanaBeneficio = null) => {
        try {
            // const api = getInitialDataToSolicitarBeneficioItemAPI();
            // await executeManageGet(api, (res) => {manejarRespuestaValidacion(res, idCampanaBeneficio);
            // }, false);
            console.log(idCampanaBeneficio);
            await getInitialDataToCreateSolicitud();
        } catch (error) {
            console.error("Error al validar solicitud", error);
        }
    };
    
    const handleSelectCampania = (campania) => {    
        console.log(campania);
        switch (campania.Origen) {
            case 'BENEFICIO':
                validarYAbrirSolicitud(campania.IdCampania);
                break;
            case 'TAILOY':
                setModalEnabled({
                    isEnable: true,
                    component: SolicitudDescuentoVale,
                    data: {
                        idEmpleado: state.user.id_empleado,                    
                    }
                });
                break;
            case 'PENSIONESCOLAR':
                setModalEnabled({
                    isEnable: true,
                    component: SolicitudDescuentoPension,
                    data: {
                        idEmpleado: state.user.id_empleado,                    
                    }
                });
                break;
            case 'CUPONERA':
                history.push('/misCuponesTiempoLibre');
                
                break;
            default:
                toast.warning(`Origen de campaña no reconocido: ${campania.Origen}`);
        }        
    }

    const TabCampanias = (
        <div style={{'background-color': '#f0f2f5'}}>
            <div className="generic-buscador-container">
                <div className='filtros-left-section'
                    style={{ 
                        display: 'flex', 
                        justifyContent: 'center', 
                        width: '100%' 
                    }}
                >
                    <button
                        onClick={() => window.open('https://heyzine.com/flip-book/528ed33e9d.html', '_blank')}
                        type='button'
                        className='generic-button-buscador'   
                        style={{
                            padding: '15px 30px', 
                            fontSize: '16px',     
                            width: 'auto',    
                            minWidth: '300px',    
                            fontWeight: 'bold',   
                            cursor: 'pointer',
                            borderRadius: '8px',
                            border: 'none',
                        }}                    
                        >
                        Descubre otros beneficios - Catálogo
                    </button>
                    
                    {/* Comentado mientras Yesenia decide que mostrar con este botón */}
                    {/* <button
                        onClick={() => window.open('/miRegistroCondicion', '_self')}
                        type='button'
                        className='generic-button-buscador'>
                        Conoce también las licencias
                    </button> */}
                </div>
            </div>
            <div className='pt-1'>
                <div>
                    
                    {!formCatalogValues.Items.length
                        ? <p className='blue-standard-color text-center mt-4'>Por ahora no contamos con ningúna campaña vigente, espera novedades próximamente</p>
                        : <>                                                                                    
                            <TableCatalogItems
                                rows={formCatalogValues.Items}
                                handleSelectCampania={handleSelectCampania}
                                isFetching={isLoading}
                            />
                        </>
                    }                    

                    <div className="px-5 mb-4">
                        <PaginatorV2
                        paginator={paginatorCatalog}
                        setPaginator={setPaginatorCatalog}
                        manageSearch={manageSearchCatalog}
                        />
                    </div>


                </div>
            </div>
        </div>
    );

    const TabListaSolicitudes = (
        <div style={{'background-color': '#f0f2f5'}}>
            <PageWrapper isLoading={isLoading}>
                                              

                <SearchContainer
                    searchCriteria={searchCriteria}
                    setSearchCriteria={setSearchCriteria}
                    setPaginator={setPaginator}
                    manageSearch={manageSearch}
                    addCleanSearch={handleCleanSearch}>
                    <PageButtons
                        hasCreateButton
                        handleCreateButton={() =>
                            getInitialDataToCreateSolicitud()
                        }
                    />
                   
                </SearchContainer>
                <TableSolicitudesBeneficios
                    formValues={formValues}
                    setFormValues={setFormValues}
                    extraData={formValues.ExtraData}
                    setModalEnabled={setModalEnabled}
                    paginator={paginator}
                    setPaginator={setPaginator}
                    keys={INIT_KEYS}
                    isAdmin={false}
                />

            </PageWrapper>
        </div>
    );

    return (
        <Wrapper className='App'>
            <PageHeader title="Mis Solicitudes de Beneficios"/>
            <ModalEnabled
                    modalEnabled={modalEnabled}
                    setModalEnabled={setModalEnabled}
                    refreshPage={manageSearch}
                />  
            <div className='container-fluid body-content' style={{'borderTop': '0.5px solid #eae5e5'}}>
                <ul
                    className='nav nav-tabs nav-groupy'
                    id='tabFicha'
                    role='tablist'
                    style={{
                        display: 'flex !important',
                        justifyContent: 'flex-start',
                        flexWrap: 'inherit',
                    }}>


                        <li className='nav-item nav-link-groupy' role='presentation'>
                            <a
                                className='nav-link active font-gothan-medium'
                                id='tabDirectorioGeneral'
                                data-toggle='tab'
                                href='#divDirectorioGeneral'
                                role='tab'
                                aria-controls='home'
                                aria-selected='true'>
                                Campañas de Beneficios Vigentes
                            </a>
                        </li>

                        <li className='nav-item nav-link-groupy' role='presentation'>
                            <a
                                className='nav-link nav-link-a font-gothan-medium'
                                id='tabDatosSede'
                                data-toggle='tab'
                                href='#divDatosSede'
                                role='tab'
                                aria-controls='contact'
                                aria-selected='false'>
                                Solicitudes de Beneficios registradas
                            </a>
                        </li>



                </ul>

                <div className='tab-content bg-white'>
                    <div 
                        className='tab-pane fade show active'
                        id='divDirectorioGeneral'
                        role='tabpanel'
                        aria-labelledby='home-tab'>
                            <div>{TabCampanias}</div>
                    </div>

                    <div
                        className='tab-pane fade'
                        id='divDatosSede'
                        role='tabpanel'
                        aria-labelledby='contact-tab'>
                            <div>{TabListaSolicitudes}</div>
                    </div>

                </div>



            </div>
        </Wrapper>
    );
}

export default MisSolicitudesBeneficios